const legacyToNewMap = {
  0: { PromotionConditionType: 1, PromotionDiscountType: 2 },
  1: { PromotionConditionType: 1, PromotionDiscountType: 5 },
  2: { PromotionConditionType: 4, PromotionDiscountType: 2 },
  3: { PromotionConditionType: 1, PromotionDiscountType: 1 },
  4: { PromotionConditionType: 1, PromotionDiscountType: 6 },
  5: { PromotionConditionType: 0, PromotionDiscountType: 6 },
  6: { PromotionConditionType: 2, PromotionDiscountType: 3 },
  7: { PromotionConditionType: 2, PromotionDiscountType: 1 },
  8: { PromotionConditionType: 5, PromotionDiscountType: 1 },
  9: { PromotionConditionType: 1, PromotionDiscountType: 3 },
  10: { PromotionConditionType: 6, PromotionDiscountType: 1 },
  11: { PromotionConditionType: 3, PromotionDiscountType: 5 },
  12: { PromotionConditionType: 4, PromotionDiscountType: 3 },
};

const newToLegacyMap = Object.entries(legacyToNewMap).reduce(
  (result, [legacyType, item]) => {
    result[`${item.PromotionConditionType}-${item.PromotionDiscountType}`] =
      Number(legacyType);
    return result;
  },
  {}
);

const discountTypesByConditionType = {
  0: [6],
  1: [1, 2, 3, 5, 6],
  2: [1, 3, 5],
  3: [5],
  4: [2, 3],
  5: [1],
  6: [1],
};

const matchItemsFreePriceProductTypes = [0, 2];
const overPriceFreeItemProductTypes = [0, 2];

const promotionRules = {
  fullQtyTotal: { conditionType: 1, discountType: 2 },
  fullQtyFreeItem: { conditionType: 1, discountType: 5 },
  matchItemsTotal: { conditionType: 4, discountType: 2 },
  matchItemsFreePrice: { conditionType: 4, discountType: 3 },
  fullQtyDiscount: { conditionType: 1, discountType: 1 },
  fullQtyChangeSalPrice: { conditionType: 1, discountType: 6 },
  noneChangeSalPrice: { conditionType: 0, discountType: 6 },
  overPriceFreePrice: { conditionType: 2, discountType: 3 },
  overPriceDiscount: { conditionType: 2, discountType: 1 },
  overPriceFreeItem: { conditionType: 2, discountType: 5 },
  nthItemDiscount: { conditionType: 5, discountType: 1 },
  fullQtyFreePrice: { conditionType: 1, discountType: 3 },
  greaterThanCountsDiscount: { conditionType: 6, discountType: 1 },
  buyAGetB: { conditionType: 3, discountType: 5 },
};

const promotionRuleGroups = {
  matchItems: ["matchItemsTotal", "matchItemsFreePrice"],
  repeatable: ["fullQtyFreePrice", "overPriceFreePrice"],
  noRuleDetailInfo: [
    "matchItemsTotal",
    "matchItemsFreePrice",
    "noneChangeSalPrice",
    "nthItemDiscount",
    "greaterThanCountsDiscount",
  ],
  noRuleInput: ["matchItemsTotal", "matchItemsFreePrice"],
  noPromotionRule: [
    "noneChangeSalPrice",
    "nthItemDiscount",
    "greaterThanCountsDiscount",
  ],
  allFoods: [
    "fullQtyTotal",
    "fullQtyFreeItem",
    "fullQtyDiscount",
    "fullQtyChangeSalPrice",
    "overPriceFreePrice",
    "overPriceDiscount",
    "nthItemDiscount",
    "fullQtyFreePrice",
    "greaterThanCountsDiscount",
  ],
};

const promotionRuleTexts = {
  overPriceFreeItem: { firstText: "滿", secondText: "送", thirdText: "個" },
  fullQtyTotal: { firstText: "滿", secondText: "個", thirdText: "元" },
  fullQtyFreeItem: { firstText: "買", secondText: "個 送", thirdText: "個" },
  fullQtyDiscount: { firstText: "滿", secondText: "個 打", thirdText: "%" },
  fullQtyChangeSalPrice: {
    firstText: "滿",
    secondText: "個 售",
    thirdText: "元",
  },
  overPriceFreePrice: { firstText: "滿", secondText: "折", thirdText: "元" },
  overPriceDiscount: { firstText: "滿", secondText: "折", thirdText: "%" },
  fullQtyFreePrice: { firstText: "滿", secondText: "個 折", thirdText: "元" },
  buyAGetB: { firstText: "買", secondText: "個 送", thirdText: "個" },
};

function getPromotionTypeKey(conditionType, discountType) {
  return `${conditionType}-${discountType}`;
}

export function getPromotionTypesFromLegacyType(promotionType) {
  return (
    legacyToNewMap[promotionType] || {
      PromotionConditionType: 0,
      PromotionDiscountType: 6,
    }
  );
}

export function getLegacyPromotionType(conditionType, discountType) {
  return newToLegacyMap[`${conditionType}-${discountType}`] ?? 5;
}

export function getDiscountTypeValuesByConditionType(
  conditionType,
  productType
) {
  const discountTypeValues = discountTypesByConditionType[conditionType] || [];
  if (
    productType != null &&
    conditionType == promotionRules.matchItemsFreePrice.conditionType &&
    !matchItemsFreePriceProductTypes.includes(Number(productType))
  ) {
    return discountTypeValues.filter(
      (value) => value != promotionRules.matchItemsFreePrice.discountType
    );
  }
  if (
    productType != null &&
    conditionType == promotionRules.overPriceFreeItem.conditionType &&
    !overPriceFreeItemProductTypes.includes(Number(productType))
  ) {
    return discountTypeValues.filter(
      (value) => value != promotionRules.overPriceFreeItem.discountType
    );
  }
  return discountTypeValues;
}

export function isValidPromotionTypePair(
  conditionType,
  discountType,
  productType
) {
  return getDiscountTypeValuesByConditionType(
    conditionType,
    productType
  ).includes(Number(discountType));
}

export function getPromotionRule(ruleName) {
  return promotionRules[ruleName];
}

export function getPromotionRuleName(conditionType, discountType) {
  const currentKey = getPromotionTypeKey(conditionType, discountType);
  return Object.keys(promotionRules).find((ruleName) => {
    const rule = promotionRules[ruleName];
    return (
      currentKey == getPromotionTypeKey(rule.conditionType, rule.discountType)
    );
  });
}

export function isPromotionRule(conditionType, discountType, ruleName) {
  return getPromotionRuleName(conditionType, discountType) == ruleName;
}

export function isPromotionRuleIn(conditionType, discountType, groupName) {
  return (promotionRuleGroups[groupName] || []).includes(
    getPromotionRuleName(conditionType, discountType)
  );
}

export function getPromotionRuleText(conditionType, discountType, textName) {
  const ruleName = getPromotionRuleName(conditionType, discountType);
  return promotionRuleTexts[ruleName]?.[textName] || "";
}
